// src/components/auth/Signup.js
import React, { useState } from 'react';
import { useAuth } from '../../AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import styles from './Auth.module.css';

const Signup = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const { signup, error } = useAuth();
  const navigate = useNavigate();

  const validatePassword = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);

    if (password.length < minLength) {
      return 'パスワードは8文字以上である必要があります';
    }
    
    if (!(hasUpperCase && hasLowerCase && hasNumbers)) {
      return 'パスワードは大文字、小文字、数字を含む必要があります';
    }
    
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // パスワードの検証
    const passwordValidationError = validatePassword(password);
    if (passwordValidationError) {
      setPasswordError(passwordValidationError);
      return;
    }
    
    // パスワード確認の一致チェック
    if (password !== confirmPassword) {
      setPasswordError('パスワードが一致しません');
      return;
    }
    
    setPasswordError('');
    setLoading(true);
    const success = await signup(email, password);
    setLoading(false);
    if (success) {
      navigate('/dashboard');
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.authCard}>
        <div className={styles.authHeader}>
          <h1 className={styles.authHeaderTitle}>BANNAI'S BAR</h1>
          <p className={styles.authSubtitle}>最高の一杯をあなたに</p>
        </div>
        
        <h2 className={styles.authTitle}>アカウント登録</h2>
        
        {error && (
          <div className={styles.errorMessage}>
            {error}
          </div>
        )}
        
        {passwordError && (
          <div className={styles.errorMessage}>
            {passwordError}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>
              メールアドレス
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={styles.formInput}
              placeholder="example@example.com"
              required
            />
          </div>
          
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>
              パスワード
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={styles.formInput}
              placeholder="パスワードを入力"
              required
            />
            <small className={styles.formHelp}>
              8文字以上、大文字・小文字・数字を含む必要があります
            </small>
          </div>
          
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>
              パスワード（確認）
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className={styles.formInput}
              placeholder="パスワードを再入力"
              required
            />
          </div>
          
          <button
            type="submit"
            disabled={loading}
            className={styles.formButton}
          >
            {loading ? '登録中...' : 'アカウント登録'}
          </button>
        </form>
        
        <div className={styles.authLinks}>
          <p className={styles.authSubtitle} style={{ marginBottom: '0.5rem' }}>すでにアカウントをお持ちの方</p>
          <Link to="/login" className={styles.authLink}>ログインへ戻る</Link>
        </div>
      </div>
    </div>
  );
};

export { Signup };